import { Component, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { formatText } from 'src/app/shared/commen-function-file';
import { SharedService } from 'src/app/service/shared/shared.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { ColDef, ExcelExportParams,GridReadyEvent, ISetFilterParams, themeQuartz, ValueFormatterParams } from 'ag-grid-community';
import { CommentDialogComponent } from 'src/app/shared/comment-dialog/comment-dialog.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-nine-box-log',
  templateUrl: './nine-box-log.component.html',
  styleUrls: ['./nine-box-log.component.scss'],
})
export class NineBoxLogComponent implements OnInit {

  buttonColorName: any
  updateLogsData: any = [];
  deleteLogsData: any = [];
  selectedTypeTabIndex: any;
  selectedTypeTabName: any = 'Deleted Reimbursement';
  EmployeeSummaryData: any;
  loggedInUserCompanyID: any;
  loggedInUserId: any;
  loggedInCompanyFiscalyear: any | null;
  pmsYears: any = []
  selectedYearForCompetency: any = null;
  fromYear: any;
  toYear: any;
  selectedYear: any;
  searchTaskString: string = '';

  constructor(public sharedService: SharedService, public router: Router,public dialog: MatDialog, private httpService: HttpService, private config: Config, private encryptionService: EncryptionService) { }

  ngOnInit() {
    this.buildColumnDefs();

    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');

    this.getpmsyearlist();
    this.getEmployee();


    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');

    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }

  }
  formatedataVariable = formatText;
  previousPage() {
    this.router.navigate(['/home/hrportal/expense']);
  }
  onClickVariablePaySetup(event: any) { }
  nextPage() {

  }
  onClickBreadcrumExpence() {
    this.router.navigate(['/home/hrportal/nineBox']);

  }

  tableDataDetails: any = [];
  onSortAssending(sortKey: any): void {
    this.updateLogsData.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => {
      if (a[sortKey] < b[sortKey]) return -1;
      if (a[sortKey] > b[sortKey]) return 1;
      return 0;
    });
  }
  onSortDesending(sortKey: any): void {
    this.updateLogsData.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => {
      if (a[sortKey] > b[sortKey]) return -1;
      if (a[sortKey] < b[sortKey]) return 1;
      return 0;
    });
  }


  onSortAssendingDeleted(sortKey: any): void {
    this.deleteLogsData.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => {
      if (a[sortKey] < b[sortKey]) return -1;
      if (a[sortKey] > b[sortKey]) return 1;
      return 0;
    });
  }
  onSortDesendingDeleted(sortKey: any): void {
    this.deleteLogsData.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => {
      if (a[sortKey] > b[sortKey]) return -1;
      if (a[sortKey] < b[sortKey]) return 1;
      return 0;
    });
  }


  // tabTypeChanged(event: MatTabChangeEvent) {
  //   this.selectedTypeTabName = event.tab.textLabel;
  //   this.selectedTypeTabIndex = event?.index;

  //    this.selectedYearForCompetency = this.apiYear;

  //   if (this.selectedTypeTabName == 'Updated Reimbursement') {

  //     this. nineBoxLogsDetails();
  //   } else {
  //     this.viewDeleteLogsDetails();
  //   }

  // }

  tabTypeChanged(event: MatTabChangeEvent) {
    this.selectedTypeTabIndex = event.index;
    this.selectedTypeTabName = event.tab.textLabel?.trim();
    this.selectedYearForCompetency = this.selectedYear;
    this.viewReimbursementByYear(this.selectedYearForCompetency);
    if (this.selectedTypeTabName == 'Updated Reimbursement') {
      this.nineBoxLogsDetails();
    } else {
      this.viewDeleteLogsDetails
    }
  }



  //viewReimbursementByYear
  viewReimbursementByYear(year: any) {

    if (this.selectedTypeTabName == 'Updated Reimbursement') {

      this.nineBoxLogsDetails();
    } else {
      this.viewDeleteLogsDetails();
    }
  }


  taskColumnHeaderInfo = [
    { label: 'Field', isMandatory: false, sortingName: 'columnName' },
    { label: 'Old Value', isMandatory: false, sortingName: 'oldValue' },
    { label: 'New Value', isMandatory: false, sortingName: 'newValue' },
    { label: 'Changed By', isMandatory: false, sortingName: 'createdAt' },
    { label: 'Changed On', isMandatory: false, sortingName: 'updatedAt' }
  ];


  taskDeletedHeaderInfo = [
    { label: 'Band', isMandatory: true, sortingName: 'band' },
    { label: 'Questions', isMandatory: true, sortingName: 'question' },
    { label: 'Weightage', isMandatory: true, sortingName: 'weightage' },
    { label: 'deletedUserName', isMandatory: true, sortingName: 'userName' },
    { label: 'Changed On', isMandatory: true, sortingName: 'updatedAt' }

  ];


  apiYear: any;


  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      const allYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
      const currentFiscalYear = `${fiscalStartYear}-${fiscalEndYear}`;

      this.pmsYears = allYears.filter((yearObj: any) => {
        const [start] = yearObj.year.split('-').map(Number);
        return start <= fiscalStartYear;
      });


      const yearValue = currentFiscalYear;
      this.setSelectedYear(yearValue);
    });
  }


  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);

    if (selectedYearObj) {
      this.selectedYear = this.selectedYearForCompetency = selectedYearObj.year;

      var test = this.selectedYearForCompetency?.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
      this.defaultCallFunctionsList();
      [this.fromYear, this.toYear] = selectedYearObj.year.split('-');
    }
  }




  defaultCallFunctionsList() {


    this.nineBoxLogsDetails()


  }





  getEmployee() {

    const request = {
      "companyId": this.loggedInUserCompanyID,
      "userId": this.loggedInUserId
    };
    this.httpService.callPostService(this.config.getTeamOfManager, request).subscribe((data: any) => {
      this.EmployeeSummaryData = data.data;
      // this. nineBoxLogsDetails();
      this.viewDeleteLogsDetails();
    })
  }

  nineBoxLogsDetails() {
    this.httpService.callGetService(`${this.config.viewLogsNineBoxUpdate}/${this.selectedYearForCompetency}/${this.loggedInUserCompanyID}`)
      .subscribe((result: any) => {
        console.log("API Response:", result); // Log full response for debugging

        if (result && result.data && Array.isArray(result.data.logs)) {
          this.updateLogsData = result.data.logs; // Assign only logs array
        } else {
          this.updateLogsData = []; // Assign empty array if logs are not found
        }

        console.log("Updated Logs Data:", this.updateLogsData); // Verify the extracted logs
      }, error => {
        console.error("Error fetching logs:", error);
        this.updateLogsData = []; // Handle errors gracefully
      });
  }









  //Delete Log
  viewDeleteLogsDetails() {
    this.httpService.callGetService(`${this.config.getviewLogsNineBoxDelete}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}/${this.loggedInUserCompanyID}`)
      .subscribe((result: any) => {
        this.deleteLogsData = result.data.content; // Ensure you get the array
        console.log("Deleted log data ",this.deleteLogsData);
      });
  }



  downloadUpdatedNineBoxLog() {
    const header = [
      "Field",
      "Old Value",
      "New Value",
      "Changed By",
      "Changed On",

    ];
    const csvRows = [header];

    this.updateLogsData.forEach((log: any) => {
      csvRows.push([
        log.columnName,
        log.oldValue,
        log.newValue,
        `${log.firstName} ${log.lastName}`,
        log.createdAt
      ]);
    });
    let csvContent = "data:text/csv;charset=utf-8," + csvRows.map(row => row.join(",")).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "updateNineBoxLogs.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }




  downloadDeletedNineBoxLog() {
    const header = [
      "Band",
      "Questions",
      "Weightage",
      "deletedUserName",
      "Changed On",

    ];
    const csvRows = [header];

    this.deleteLogsData.forEach((log: any) => {
      csvRows.push([
        log.band,
        log.question,
        log.weightage,
        log.userName,
        log.updatedAt
      ]);
    });

    let csvContent = "data:text/csv;charset=utf-8," + csvRows.map(row => row.join(",")).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "deletedNineBoxLogs.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  
  // --------------------------------AG GRID CODE---------------------------------------------------------
  gridApi: any;
  paginationPageSizeSelector = [5, 10, 20,50,100,200,500,1000];
  pagination = true;
  paginationPageSize = 10;
  detailRowAutoHeight = true;

  // defaultColDef: ColDef = {
  //   flex: 1,
  //   minWidth: 100,
  //   filter: true,
  //   resizable: true,
  //   sortable: true,
  //   floatingFilter: false,  // ✅ small filter box under header
  // };
  
  // gridOptions: any = {
  //   defaultColDef: {
  //     resizable: true,
  //     sortable: true,
  //     filter: true,
  //     floatingFilter: true,
  //     minWidth: 80,
  
  //     // ✅ add this
  //     cellClass: (p: any) => (p.node.rowIndex % 2 === 0 ? 'cell-even' : 'cell-odd')
  //   },
  //   context: { componentParent: this },
  //   rowSelection: 'single',
  //   localeText: {
  //     noRowsToShow: 'No Data Found'  // default text ko replace karna hai 'No Rows To Show' to 'No Data Found'
  //   }
  // };

  openCommentModal(text: string,commentType:any) {
    this.dialog.open(CommentDialogComponent, {
      width: '600px',
      data: { 
        text: text,
        commentType: commentType
      }
    });
  
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    params.api.sizeColumnsToFit();
    console.log(params)
  }
  formatStatus(value: any): string {
    if (!value || typeof value !== 'string') {
      return 'N/A'; // fallback agar value string na ho
    }

    // Camel Case → Title Case
    return value
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  formatDate(value: any): string {
    if (!value) return 'N/A';
  
    const date = new Date(value);
    if (isNaN(date.getTime())) return 'Invalid Date';
  
    // dd-MM-yyyy format
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
  
    return `${day}-${month}-${year}`;
  }

  
  // Helper function to convert any date string into dd-MM-yyyy
  formatDateOnly(dateStr: string | null): string | null {
    if (!dateStr) return null;
  
    let datePart = dateStr;
    if (dateStr.includes('T')) {
      datePart = dateStr.split('T')[0];  
    }
  
    const [y, m, d] = datePart.split('-').map(Number);
    if (!y || !m || !d) return null;
  
    // Date object 
    const date = new Date(y, m - 1, d);
  
    // Format dd-MM-yyyy
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }
  
  // ✅ Global search function
  onFilterTextBoxChanged(value: string = '') {
    if (!this.gridApi) return;
  
    // v31+ way:
    this.gridApi.setGridOption('quickFilterText', value ?? '');
   
  }

onBtExport(strMsg: any) {
  const paramsBase: ExcelExportParams = {
    fileName: strMsg + '_' + new Date().toISOString().slice(0, 10) + '.xlsx',
    sheetName: strMsg,
    exportAsExcelTable: {
      showRowStripes: true,
      name: strMsg
    },

    processCellCallback: (cell: any) => {
      const colDef = cell.column.getColDef();
      const colId: string = cell.column.getColId?.() ?? colDef.field ?? "";
      const data = cell.node?.data || {};
      const header = (colDef.headerName ?? "").toString();
      const value = cell.value;

      const findKey = (obj: any, regex: RegExp): string | undefined => {
        if (!obj || typeof obj !== "object") return undefined;
        const keys = Object.keys(obj);
        return keys.find(k => regex.test(k));
      };

      const oldKeyRegexList = [
        /^old(value)?$/i,
        /(old|previous|prev)/i,
        /old_value/i,
        /oldVal/i,
        /^from$/i
      ];

      const newKeyRegexList = [
        /^new(value)?$/i,
        /(new|current|updated|to)/i,
        /new_value/i,
        /newVal/i,
        /^to$/i
      ];

      const isOldColumn =
        /(old|previous|prev)/i.test(colId) ||
        /(old|previous|prev)/i.test(header);

      const isNewColumn =
        /(new|current|updated|to)/i.test(colId) ||
        /(new|current|updated|to)/i.test(header);

      // Normalizer: remove trailing .0 for integer-like values and stringify
      const normalizeValue = (val: any): string => {
        if (val === null || val === undefined) return "";
        if (typeof val === "number") {
          // if whole number like 40.0 -> "40", otherwise keep decimal
          return Number.isInteger(val) ? String(val) : String(val);
        }
        if (typeof val === "string") {
          // strings that look like numbers "40.0" or "040.0"
          if (/^[+-]?\d+(\.0+)?$/.test(val)) {
            return String(Number(val));
          }
          return val;
        }
        if (Array.isArray(val)) {
          return val.map(v => normalizeValue(v)).join(", ");
        }
        return String(val);
      };

      if (isOldColumn) {
        let key: string | undefined;
        for (const rx of oldKeyRegexList) {
          key = findKey(data, rx);
          if (key) break;
        }
        const cellVal =
          (key ? data[key] : undefined) ??
          data.oldValue ??
          data.old_value ??
          data.previous ??
          data.prev ??
          "";

        const out = Array.isArray(cellVal) ? (cellVal as any[]).map(normalizeValue).join(", ") : normalizeValue(cellVal);
        // force Excel to treat cell as text for consistent alignment (leading apostrophe invisible in display)
        return "'" + out;
      }

      if (isNewColumn) {
        let key: string | undefined;
        for (const rx of newKeyRegexList) {
          key = findKey(data, rx);
          if (key) break;
        }
        const cellVal =
          (key ? data[key] : undefined) ??
          data.newValue ??
          data.new_value ??
          data.current ??
          data.to ??
          "";

        const out = Array.isArray(cellVal) ? (cellVal as any[]).map(normalizeValue).join(", ") : normalizeValue(cellVal);
        return "'" + out;
      }

      // Date formatting
      const dateColumns = ["updatedAt", "endDate", "changedOn"];
      if (dateColumns.includes(colId) && value) {
        const date = new Date(value);
        if (!isNaN(date.getTime())) {
          return (
            ("0" + date.getDate()).slice(-2) +
            "-" +
            ("0" + (date.getMonth() + 1)).slice(-2) +
            "-" +
            date.getFullYear()
          );
        }
      }

      // Status formatting
      if (header === "Status" && value) {
        return value
          .toString()
          .toLowerCase()
          .replace(/_/g, " ")
          .replace(/\b\w/g, (c: string) => c.toUpperCase());
      }

      return value ?? "";
    }
  };

  // --- export only current page ---
  const api = this.gridApi;
  if (!api) return;

  const hasPagination =
    typeof api.paginationGetCurrentPage === "function" &&
    typeof api.paginationGetPageSize === "function" &&
    typeof api.getDisplayedRowCount === "function" &&
    typeof api.getDisplayedRowAtIndex === "function";

  if (!hasPagination) {
    api.exportDataAsExcel(paramsBase);
    return;
  }

  const currentPage = api.paginationGetCurrentPage();
  const pageSize = api.paginationGetPageSize();
  const displayedCount = api.getDisplayedRowCount();
  const start = currentPage * pageSize;
  const end = Math.min(start + pageSize, displayedCount);

  const pageNodeIds = new Set<string>();
  for (let i = start; i < end; i++) {
    const node = api.getDisplayedRowAtIndex(i);
    if (node) pageNodeIds.add(node.id);
  }

  api.exportDataAsExcel({
    ...paramsBase,
    shouldRowBeSkipped: (params: { node: any }) => {
      const node = params.node;
      // include pinned rows if needed:
      // if (node.rowPinned) return false;
      return !pageNodeIds.has(node.id);
    }
  });
}





  approvalRenderer(params: any) {
    if (!params.value) return '';
        const status = params.value.toUpperCase();
      
        let color = '';
        if (status === 'APPROVED') {
          color = '#4caf50'; // green
        } else if (status === 'REJECTED') {
          color = '#f44336'; // red
        } else if (status === 'PENDING') {
          color = '#ff9800'; // orange
        }
      
        return `
          <span style="
            border: 1px solid ${color};
            color: ${color};
            padding: 4px 10px;
            border-radius: 12px;
            font-size: 12px;
            font-weight: 500;
            display: inline-block;
            line-height: 20px;
            white-space: nowrap;
          ">
        ${status.charAt(0) + status.slice(1).toLowerCase()}
      </span>
    `;
  }

  statusFormatter(params: any): string {
    if (!params.value) return '';
  
    const valueUpper = params.value.toUpperCase();
  
    // 🔹 Status → Color map
    const statusColors: Record<string, string> = {
      'APPROVED_BY_FINANCE_BUT_NOT_PAID': '#4caf50', // green
      'APPROVED_BY_MANAGER_SENT_TO_FINANCE': '#4caf50',
      'APPROVED_BY_MANAGER_REJECTED_BY_FINANCE': '#f44336', // red
      'REJECTED_BY_MANAGER': '#f44336',
      'PENDING_WITH_MANAGER': '#ff9800' // orange
    };
  
    // 🔹 Default color = grey
    const color =
      Object.keys(statusColors).find(key => valueUpper.includes(key))
        ? statusColors[
            Object.keys(statusColors).find(key => valueUpper.includes(key))!
          ]
        : '#999';
  
    // 🔹 Convert to Title Case
    const formattedText = params.value
      .toLowerCase()
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  
    return `
      <span style="
        border: 1px solid ${color};
        color: ${color};
        padding: 4px 10px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 500;
        display: inline-block;
        white-space: normal;
        word-wrap: break-word;
        line-height: 1.4em;
        animation: fadeInScale 0.3s ease-in-out;
        max-width: 100%;
      ">
        ${formattedText}
      </span>
    `;
  }
  
  dateRenderer(params: any) {
    if (!params.value) return '';
    const date = new Date(params.value);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  dateComparator(valueA: string, valueB: string) {
    const parseDate = (value: string) => {
      if (!value) return null;
      // Agar backend se yyyy-mm-dd aa raha hai:
      if (value.includes('-') && value.indexOf('-') === 4) {
        return new Date(value).getTime();
      }
      // Agar already dd-mm-yyyy format hai:
      const [day, month, year] = value.split('-').map(Number);
      return new Date(year, month - 1, day).getTime();
    };

    const dateA = parseDate(valueA);
    const dateB = parseDate(valueB);

    if (dateA === dateB) return 0;
    if (dateA == null) return -1;
    if (dateB == null) return 1;
    return dateA - dateB;
  }

  openFile(fileUrl: string) {
    window.open(fileUrl, '_blank');
  }
  downloadRenderer = (params: any) => {
    
    const fileUrl = `${this.config.downloadFile}${params.value}`;
    if (!params.value) return '';
    const img = document.createElement('img');
    img.src = 'assets/icon/yellowdownload.png'; // replace with your icon path
    img.alt = 'download';
    img.style.width = '18px';
    img.style.height = '18px';
    img.style.cursor = 'pointer';
    img.title = params.value;
    img.addEventListener('click', (e) => {
      e.stopPropagation();
      // open file in new tab
      window.open(fileUrl, '_blank');
    });
    return img;
  }

  downloadDialogRenderer(fileName: string): string {
    if (!fileName) return '';
    return `${this.config.downloadFile}${fileName}`;
  }
  selectedRow: any;
  isDetailsOpen = false;
  onRowClicked(event: any) {
    console.log(event.data);
    this.selectedRow = event.data;
    this.isDetailsOpen = true;
  }
  closeDetails() {
    this.isDetailsOpen = false;
  }

 isClicked = false;
 

  resetGrid() {
    this.isClicked = false; // Trigger animation
  
    if (this.gridApi) {
      // ✅ Reset filters & sorting
      this.gridApi.setFilterModel(null);
      // this.gridApi.setSortModel(null);
      this.gridApi.deselectAll();
  
      // ✅ Reset quick filter (search box)
      this.searchTaskString = '';
      this.gridApi.setGridOption('quickFilterText', ''); // Clears quick filter text
  
      // ✅ Reset pagination
      this.paginationPageSize = 10;
      this.gridApi.setGridOption('paginationPageSize', this.paginationPageSize);
      this.gridApi.paginationGoToFirstPage();
  
      // ✅ Force refresh so UI input also clears
      this.gridApi.refreshCells();
      this.gridApi.resetColumnState();         // ✅ Reset columns
    }
  }
  columnDefs: ColDef[] = [];
  defaultColDef: ColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    minWidth: 120
  };
  buildColumnDefs() {
    this.columnDefs = this.taskColumnHeaderInfo.map((col: any) => {
      const column: ColDef = {
        headerName: col.label,
        field: col.sortingName,
        sortable: true,
        filter: true,
        resizable: true,
        minWidth: 120,
        tooltipField: col.sortingName, // show full value on hover
        cellStyle: { whiteSpace: 'normal', lineHeight: '1.4em' },
      };
  
      // 🟦 1️⃣ FIELD COLUMN (Field)
      if (col.sortingName === 'columnName') {
        column.headerName = 'Field';
      }
  
      // 🟩 2️⃣ OLD VALUE COLUMN
      if (col.sortingName === 'oldValue') {
        column.headerName = 'Old Value';
        column.tooltipField = 'oldValue';
      }
  
      // 🟧 3️⃣ NEW VALUE COLUMN
      if (col.sortingName === 'newValue') {
        column.headerName = 'New Value';
        column.tooltipField = 'newValue';
      }
  
      // 🟪 4️⃣ CHANGED BY COLUMN
      if (col.sortingName === 'createdAt') {
        column.headerName = 'Changed By';
        column.valueGetter = (params: any) =>
          `${params.data.firstName || ''} ${params.data.lastName || ''}`.trim() || 'N/A';
        column.cellStyle = { fontWeight: '500' };
      }
  
      // 🟨 5️⃣ CHANGED ON COLUMN
      if (col.sortingName === 'updatedAt') {
        column.headerName = 'Changed On';
        column.cellRenderer = this.dateRenderer.bind(this);
        column.comparator = this.dateComparator.bind(this);
        column.cellStyle = { color: '#424242' };
      }
  
      return column;
    });
  }
  deleteLogsColumnDefs: ColDef[] = [
    { headerName: 'Band', field: 'band', sortable: true, filter: true },
    { headerName: 'Question', field: 'question', sortable: true, filter: true, 
      cellRenderer: (params: any) => {
      if (!params.value) return ''; // null/undefined case me blank return karega
      const shortText = params.value?.length > 30 
        ? params.value.substring(0, 30) + '...' 
        : params.value;
   
      return `<span class="clickable-comment">${shortText}</span>`;
    },
    onCellClicked: (params: any) => {
      if (params.value) {
        // console.log(params)
        params.context.componentParent.openCommentModal(params.value,'Question');
      }
    }
    },
    { headerName: 'Weightage', field: 'weightage', sortable: true, filter: true },
    { headerName: 'Updated By', field: 'userName', sortable: true, filter: true, cellStyle: { fontWeight: '500' } },
    {
      headerName: 'Updated On',
      field: 'updatedAt',
      sortable: true,
      // filter: true,
      cellRenderer: (params: any) => this.dateRenderer(params),
      comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
      filter: 'agDateColumnFilter',
      minWidth: 165,
      filterParams: {
        filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
        suppressAndOrCondition: true,  // ✅ AND/OR hide
        maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
      }
    }
  ];
  
// --------------------------------AG GRID CODE---------------------------------------------------------
   

}
